import { Validation } from './validation';
import {
    EmailValidator,
    NumberValidator,
    PatternValidator,
    RequiredValidator,
    StringLengthValidator,
} from './validators';

const validation = new Validation();
validation.registerValidator(EmailValidator.getIdentifier(), EmailValidator);
validation.registerValidator(RequiredValidator.getIdentifier(), RequiredValidator);
validation.registerValidator(StringLengthValidator.getIdentifier(), StringLengthValidator);
validation.registerValidator(PatternValidator.getIdentifier(), PatternValidator);
validation.registerValidator(NumberValidator.getIdentifier(), NumberValidator);

export {
    validation,
};
